<template>
    <div class="TQ_center TQ_font_SecularOne">

        <!-- what is TQ-->
        <div class="TQ_padding_16px TQ_bg_white TQ_margin_bottom_8px TQ_border_darkGray TQ_borderBox">

            <div class="TQ_inline TQ_verticalAlignMiddle TQ_padding_16px">
                <tq-image :pb_src_r="ass_img_about_tqAppGif" class="TQ_maxWidth_200px TQ_width_100p"/>
            </div>

            <div class="TQ_inline TQ_verticalAlignMiddle TQ_maxWidth_450px TQ_text_20px TQ_padding_16px">

                <h1 class="TQ_text_40px TQ_margin_bottom_16px">{{ass_strings.fourWords_whatIsTravelQuest[store_system_langCode_ve.val]}}?</h1>

                <div class="TQ_maxWidth_350px TQ_center">
                    {{ass_strings.sentenceGroup_about1[store_system_langCode_ve.val]}}
                </div>
            </div>

        </div>

        <!-- works on all platforms  -->
        <div class="TQ_padding_16px TQ_bg_white TQ_margin_bottom_8px TQ_border_darkGray  TQ_borderBox ">


            <div class="TQ_inline TQ_verticalAlignMiddle TQ_maxWidth_350px TQ_text_20px TQ_padding_16px">

                <h2 class="TQ_text_40px TQ_margin_bottom_16px">{{ass_strings.oneWord_how[store_system_langCode_ve.val]}}?</h2>

                <div>
                    {{ass_strings.sentenceGroup_about2[store_system_langCode_ve.val]}}.
                </div>

                <div class="TQ_margin_bottom_16px">
                    {{ass_strings.sentenceGroup_about3[store_system_langCode_ve.val]}}.
                </div>

                <div class="">
                    <img :src="ass_img_googleStore" class="TQ_maxWidth_150px TQ_clickable TQ_box_shadow TQ_padding_4px TQ_borderRadius TQ_bg_black" @click="m_openGoogleStore_f()"/>
                    <div class="TQ_padding_16px TQ_inline"/>
                    <img :src="ass_img_appStore" class="lc_appStore TQ_clickable TQ_box_shadow TQ_padding_4px TQ_borderRadius TQ_bg_black" @click="m_openAppStore_f"/>
                </div>
            </div>

            <div class="TQ_inline TQ_verticalAlignMiddle TQ_padding_16px">
                <tq-image :pb_src_r="ass_img_about_multiPlatform" class="TQ_maxWidth_450px TQ_width_100p"/>
            </div>

        </div>

        <!-- type of quests  -->
        <div class="TQ_padding_16px TQ_bg_white TQ_margin_bottom_8px TQ_border_darkGray TQ_borderBox ">

            <h2 class="TQ_text_40px">{{ass_strings.twoWords_questsTypes[store_system_langCode_ve.val]}}</h2>
            <br><br><br>

            <tq-images-carousel
                    :p_images-url_as="[ass_img_about_cards, ass_img_about_map_route, ass_img_about_missionList, ass_img_about_map_rectangles,ass_img_about_missionList_levels]"
                    :p_images-title_a_blc_s="[ass_strings.oneWord_cards, ass_strings.oneWord_route, ass_strings.twoWords_missionsList, ass_strings.oneWord_squares, ass_strings.oneWord_levels]"
                    :p_system_lang-code_e="store_system_langCode_ve.val"
            />


            <div @click="m_moveToArticlePage_f(enum_articlesIds.questsType_uid)" class="TQ_link TQ_text_24px TQ_margin_top_32px TQ_inline">
                {{ass_strings.fourWords_clickForMoreInfo[store_system_langCode_ve.val]}}
            </div>

        </div>

        <!-- locks -->
        <div class="TQ_padding_32px TQ_bg_white TQ_margin_bottom_8px TQ_border_darkGray TQ_borderBox "  >

            <h2 class="TQ_text_40px">{{ass_strings.oneWord_locks[store_system_langCode_ve.val]}}</h2>

            <c_-about_-locks class="TQ_direction_rtl" :p_system-lang-code_e="store_system_langCode_ve.val"/>

            <div @click="m_moveToArticlePage_f(enum_articlesIds.locksType_uid)" class="TQ_link TQ_text_24px TQ_margin_top_16px">
                {{ass_strings.fourWords_clickForMoreInfo[store_system_langCode_ve.val]}}
            </div>

        </div>

        <!-- pricing -->
        <tq-pricing class="TQ_border_darkGray TQ_margin_bottom_8px"></tq-pricing>

        <!-- social platform  -->
        <div class="TQ_padding_32px TQ_bg_white TQ_margin_bottom_8px TQ_border_darkGray TQ_borderBox" >

            <h2 class="TQ_text_40px TQ_text_capitalize">{{ass_strings.twoWords_socialPlatform[store_system_langCode_ve.val]}}</h2>

            <!--<div class="TQ_text_bold  TQ_textColor_purple TQ_text_32px TQ_text_capitalize">-->
            <!--    {{ass_strings.twoWords_socialPlatform[store_system_langCode_ve.val]}}-->
            <!--</div>-->
            <div class="TQ_text_20px">
                {{ass_strings.sentence_aboutNewCreator1[store_system_langCode_ve.val]}}.
            </div>
            <div class="TQ_text_20px">
                {{ass_strings.sentence_aboutNewCreator2[store_system_langCode_ve.val]}}.
            </div>

            <div class="TQ_maxWidth_400px TQ_center " >

                <div class="TQ_textAlign_initial">

                    <!-- full name -->
                    <div class="TQ_margin_top_8px">
                        <div class="TQ_textAlign_initial TQ_text_14px TQ_textColor_purple">
                            {{ass_strings.twoWords_fullName[store_system_langCode_ve.val]}}
                        </div>
                        <input class="TQ_bg_gray4 TQ_borderRadius TQ_border TQ_padding_8px TQ_text_20px TQ_width_100p TQ_borderBox"
                               v-model="newCreatorInfo_o.name"
                               :placeholder="ass_strings.twoWords_fullName[store_system_langCode_ve.val]">
                    </div>

                    <!-- email -->
                    <div class="TQ_margin_top_8px">
                        <div class="TQ_textAlign_initial TQ_text_14px TQ_textColor_purple">
                            {{ass_strings.oneWord_email[store_system_langCode_ve.val]}}
                        </div>
                        <input class="TQ_bg_gray4 TQ_borderRadius TQ_border TQ_padding_8px TQ_text_20px TQ_width_100p TQ_borderBox"
                               v-model="newCreatorInfo_o.email"
                               :placeholder="ass_strings.oneWord_email[store_system_langCode_ve.val]">
                    </div>

                    <!-- phone number -->
                    <div class="TQ_margin_top_8px">
                        <div class="TQ_textAlign_initial TQ_text_14px TQ_textColor_purple">
                            {{ass_strings.oneWord_phone[store_system_langCode_ve.val]}}
                        </div>
                        <input class="TQ_bg_gray4 TQ_borderRadius TQ_border TQ_padding_8px TQ_text_20px TQ_width_100p TQ_borderBox"
                               v-model="newCreatorInfo_o.phone"
                               :placeholder="ass_strings.oneWord_phone[store_system_langCode_ve.val]">
                    </div>

                    <!-- more info -->
                    <div class="TQ_margin_top_16px">
                        <div class="TQ_textAlign_initial TQ_text_14px TQ_textColor_purple">
                            {{ass_strings.twoWords_moreInfo[store_system_langCode_ve.val]}}
                        </div>
                        <tq-textarea
                            pb_uid_s="moreInfo"
                            pb_textarea-class_s="TQ_padding_8px TQ_bg_gray4 TQ_borderRadius TQ_border TQ_text_16px"
                            :pb_max-length_n="300"
                            :pb_placeholder_s="ass_strings.twoWords_moreInfo[store_system_langCode_ve.val]"
                            :pb_rows_n="5"
                            :pe_change-text_s="(text_s) => {newCreatorInfo_o.moreInfo = text_s}"
                        />
                    </div>
                </div>

            </div>


            <div class="TQ_padding_8px TQ_maxWidth_400px TQ_center">
                <tq-loader-button :show-loader="btn_showLoader_b" class="TQ_width_100p">
                    <div @click="m_sendEmailToCreator_f" class="TQ_padding_8px TQ_bg_green TQ_borderRadius TQ_margin_top_8px TQ_box_shadow TQ_text_20px TQ_clickable">
                        {{ass_strings.oneWord_send[store_system_langCode_ve.val]}}
                    </div>
                </tq-loader-button>

            </div>

        </div>

        <!-- popup - feature more info -->
        <tq-popup v-if="features_o.selectedFeatureLabel_e" :show="features_o.showPopup_moreInfo_vb" max-width="500px"  >

            <fcc-display-slides-data
                v-if="server_featureMoreInfo_byLabel_c[features_o.selectedFeatureLabel_e]"
                :p_slides-data_ac="server_featureMoreInfo_byLabel_c[features_o.selectedFeatureLabel_e].so_slides_blc_ac[server_featureMoreInfo_byLabel_c[features_o.selectedFeatureLabel_e].ml_m_displayLang_fe(store_system_langCode_ve.val)]"
                :pe_click-finish_f="() => {features_o.showPopup_moreInfo_vb.val=false}"/>

            <tq-image v-else :pb_src_r="ass_image_coming_soon" class="TQ_width_100p" />

        </tq-popup>

        <!-- hide-->
        <div v-if="false">

            <!-- users  -->
            <div class="TQ_padding_32px TQ_bg_white TQ_margin_bottom_8px TQ_border TQ_borderBox" >

                <!-- non profit - 80% off-->
                <div class="TQ_margin_8px TQ_padding_16px TQ_inline TQ_width_250px TQ_verticalAlignTop TQ_box_shadow2 TQ_borderRadius">
                    <tq-image :pb_src_r="ass_svg_nonProfit_purple" class="TQ_width_60px"/>
                    <div>
                        ארגונים ללא רווח
                    </div>
                    <hr>
                    <div>
                        אנו אוהבים לעבוד עם קבוצות ללא מטרות רווח, ארגונים אזרחיים ועיריות למען גיוס תרומות ואירועים בקהילה.
                        צור קשר כדי לברר מידע נוסף על האופן שבו TravelQuest יכול לתמוך בך ובקהילה שלך.
                    </div>
                    <hr>
                    <div class="TQ_bg_purple TQ_padding_4px TQ_box_shadow TQ_borderRadius TQ_clickable">
                        צרו קשר
                    </div>
                </div>

                <!-- schools - 70% off-->
                <div class="TQ_margin_8px TQ_padding_16px TQ_inline TQ_width_250px TQ_verticalAlignTop TQ_box_shadow2 TQ_borderRadius">
                    <tq-image :pb_src_r="ass_svg_schools_purple" class="TQ_width_60px"/>
                    <div>
                        מורים
                    </div>
                    <hr>
                    <div>
                        העברו את השיעור שלכם בצורת משחק מהנה
                    </div>
                    <hr>
                    <div class="TQ_bg_purple TQ_padding_4px TQ_box_shadow TQ_borderRadius TQ_clickable">
                        צרו קשר
                    </div>
                </div>

                <!-- Museums - 50% off -->
                <div class="TQ_margin_8px TQ_padding_16px TQ_inline TQ_width_250px TQ_verticalAlignTop TQ_box_shadow2 TQ_borderRadius">
                    <tq-image :pb_src_r="ass_svg_museum_purple" class="TQ_width_60px"/>
                    <div>
                        מוזיאונים
                    </div>
                    <hr>

                    <div>
                        סיור במוזיאון בצורת משחק
                    </div>
                    <hr>
                    <div class="TQ_bg_purple TQ_padding_4px TQ_box_shadow TQ_borderRadius TQ_clickable">
                        צרו קשר
                    </div>
                </div>

                <!-- small business - 20% off -->
                <div class="TQ_margin_8px TQ_padding_16px TQ_inline TQ_width_250px TQ_verticalAlignTop TQ_box_shadow2 TQ_borderRadius">
                    <tq-image :pb_src_r="ass_svg_museum_purple" class="TQ_width_60px"/>
                    <div>
                        עסקים קטנים
                    </div>
                    <hr>

                    <div>
                        עסקים קטנים? השתמשו במערכת בשביל להגדיל וכו
                    </div>
                    <hr>
                    <div class="TQ_bg_purple TQ_padding_4px TQ_box_shadow TQ_borderRadius TQ_clickable">
                        צרו קשר
                    </div>
                </div>
            </div>

            <!-- Q&A -->
            <div class="TQ_padding_32px TQ_bg_white TQ_margin_bottom_8px TQ_border TQ_borderBox "  >

                <h2 class="TQ_text_40px">שאלות ותשובות</h2>

                <!-- question and answers-->
                <div class="TQ_margin_top_16px">

                    <div class="TQ_padding_8px TQ_maxWidth_700px TQ_align_initial TQ_center">

                        <div class="TQ_padding_4px">
                            <div class="TQ_text_bold">
                                מקבלים התראות על לפי ביצעו התשלום?
                            </div>
                            <div>
                                כן בכל ה-1 לחודש תקבלו פירוט מלא של החיוב הקרוב.
                            </div>
                        </div>
                        <div class="TQ_padding_4px">
                            <div class="TQ_text_bold">
                                מתי מתבצע התשלום
                            </div>
                            <div>
                                ב-10 לחודש העוקב
                            </div>
                        </div>
                        <div class="TQ_padding_4px">
                            <div class="TQ_text_bold">
                                ניתן לשנות כרטיס שנוצר?
                            </div>
                            <div>
                                כל עד לא בוצע התשלום ב10 לחודש ניתן לשנות את הכרטיס שנוצר.
                            </div>
                        </div>
                        <div class="TQ_padding_4px">
                            <div class="TQ_text_bold">
                                צריך עזרה ביצירת הפעילות שלך?
                            </div>
                            <div>
                                מוזמן להיכנס למאמרים הבאים, או ליצור איתנו קשר,
                                להצעת מחיר של בניית קווסט מותאם אישית לכם על ידי איש מקצוע.
                            </div>
                        </div>
                        <div class="TQ_padding_4px">
                            <div class="TQ_text_bold">
                                איך נכנסים לשחק??
                            </div>
                            <div>
                            </div>
                        </div>
                        <div class="TQ_padding_4px">
                            <div class="TQ_text_bold">
                                איך יוצרים משחקים זה מסובך?
                            </div>
                            <div>
                            </div>
                        </div>
                        <div class="TQ_padding_4px">
                            <div class="TQ_text_bold">
                                סוכן 5 אחוזים
                            </div>
                            <div>
                            </div>
                        </div>



                    </div>
                </div>

            </div>

            <!-- quest includes -->
            <div class="TQ_padding_32px TQ_bg_white TQ_margin_bottom_8px TQ_border TQ_borderBox" >

                <div class="TQ_text_40px TQ_margin_bottom_8px ">ממה מורכב משחק?</div>

                <div class="TQ_maxWidth_px TQ_textAlign_initial TQ_inline">

                    <!-- game type -->
                    <div class="TQ_margin_bottom_8px">

                        <div class="TQ_text_20px">
                            1) סוג המשחק:
                        </div>
                        <div>
                            איך המשימות מוצגות לשחקנים, ואיך עוברים בין החידות.
                        </div>
                    </div>

                    <!-- missions -->
                    <div class="TQ_margin_bottom_8px">
                        <div class="TQ_text_20px">
                            2) משימות:
                        </div>
                        <div>
                            שמורכבות מתוכן ומנעולים.
                        </div>
                    </div>

                    <!-- מנעולים -->
                    <div class="TQ_margin_bottom_8px">
                        <div class="TQ_text_20px">
                            3) מנעולים:
                        </div>
                        <div >
                            בשביל לסיים משימה על השחקן לסיים את כל המנעולים של אותו משימה.
                        </div>
                    </div>


                </div>

            </div>

            <!-- Guides -->
            <div class="TQ_padding_16px TQ_bg_white TQ_margin_bottom_8px TQ_border" >
                <div class="TQ_text_40px TQ_margin_bottom_8px">מדריכים</div>

                <div class="TQ_padding_8px TQ_inline">
                    <div class="TQ_text_20px"> סוגי משחקים </div>

                    <object data="http://www.youtube.com/embed/W7qWa52k-nE"
                            width="560" height="315"></object>
                </div>

                <div class="TQ_padding_8px TQ_inline">
                    <div class="TQ_text_20px">עריכת משימה </div>

                    <object data="http://www.youtube.com/embed/W7qWa52k-nE"
                            width="560" height="315"></object>
                </div>


                <div class="TQ_padding_8px TQ_inline">
                    <div class="TQ_text_20px"> שיתוף המשחק </div>

                    <object data="http://www.youtube.com/embed/W7qWa52k-nE"
                            width="560" height="315"></object>
                </div>

                <div class="TQ_padding_8px TQ_inline">
                    <div class="TQ_text_20px"> תשלומים </div>

                    <object data="http://www.youtube.com/embed/W7qWa52k-nE"
                            width="560" height="315"></object>
                </div>

            </div>

            <!-- Tips for new creator -->
            <div class="TQ_padding_16px TQ_bg_white TQ_margin_bottom_8px">
                <div class="TQ_text_40px TQ_margin_bottom_8px">טיפים</div>

                <div class="TQ_padding_8px TQ_inline">
                    <div class="TQ_text_20px"> משמות קלות לקשות</div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>

    import TqCard from '../../components/basic/TqCard'
    import Si_Logo from "../../components/a_smartIcons/si_Logo";
    import {route_moveToRoute, route_openNewWindow_f} from "@/router";
    import {
        enum_articlesIds,
        enum_costCurrency_n, enum_featuresMinPoints, enum_levelLabels, enum_levelMaxPoints, enum_moreInfo_helpersIds_s,
        enum_moreInfoImgOptions_e,
        enum_moveToOptions,
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import TqOnTopContainer from "../../components/basic/TqOnTopContainer";
    import {
        ass_img_about_multiPlatform,
        ass_img_about_missionList_levels,
        ass_img_about_missionList,
        ass_img_about_map_route,
        ass_img_about_map_rectangles,
        ass_img_about_cards,
        ass_img_googleStore,
        ass_img_appStore,
        ass_img_about_tqAppGif,
        ass_img_info2_b,
        ass_img_garbage_w,
        ass_img_add_w,
        ass_img_ticket2_g,
        ass_img_ticket2_blue,
        ass_img_ticket2_black,
        ass_img_ticket2_o,
        ass_img_ticket2_p,
        ass_img_lock_w,
        ass_svg_map_w,
        ass_img_idea_w,
        ass_svg_museum_store,
        ass_svg_schools_store,
        ass_svg_nonProfit_store,
        ass_svg_store_black,
        ass_img_tickets_b,
        ass_svg_maze_circular_c,
        ass_svg_maze_hexagonal_c,
        ass_svg_maze_heart_c,
        ass_svg_maze_triangular_ca,
        ass_svg_maze_star_c,
        ass_svg_maze_square_c,
        ass_svg_maze_rhombus_c,
        ass_svg_maze_rectangular_c,
        ass_svg_maze_oval_c,
        ass_svg_maze_octagonal_c,
        ass_svg_maze_triangular_g,
        ass_svg_maze_square_g,
        ass_svg_maze_rectangular_g,
        ass_svg_maze_hexagonal_g,
        ass_svg_maze_octagonal_g,
        ass_svg_maze_rhombus_g,
        ass_svg_maze_heart_g,
        ass_svg_maze_circular_g,
        ass_svg_maze_oval_g,
        ass_svg_maze_star_g,
        ass_image_coming_soon,
        ass_img_playersGroup_b,
        ass_img_edit_b,
        ass_img_xLetter_b,
        ass_img_checked_b,
        ass_svg_airplane_w,
        ass_svg_hot_air_balloon_w,
        ass_svg_paper_airplane2_w, ass_svg_rocket2_w,
    } from "@/assets/scripts/Ass_Files";
    import Si_maze from "../../components/a_smartIcons/si_maze";
    import TqImage from "../../components/basic/TqImage";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {store_getStateValue_vo, store_var} from "@/store";
    import {helper_getDirectionByLangCode_fe} from "@/scripts/S_Helper";
    import Si_fullLogo from "../../components/a_smartIcons/si_fullLogo";
    import {gv_urls} from "@/scripts/S_GlobalVar";
    import C_About_Locks from "./v_About/c_About_Locks";
    import TqPopup from "../../components/basic/TqPopup";
    import TqImagesCarousel from "../../components/basic/TqImagesCarousel";
    import TqTextarea from "../../components/basic/TqTextarea";
    import {
        server_sendMail_fp,
        serverPre_moreInfo_get_one_f
    } from "@/scripts/Server/S_ServerPre";
    import {notification_notify} from "../../scripts/S_Notification";
    import TqLoaderButton from "../../components/basic2/TqLoaderButton";
    import {FB_Cost, FB_QuestTicket, FB_SendEmail} from "../../../functions/src/shareCode/Share_S_Classes";
    import {
        format_bigNumber_fs,
        format_cost_s,
    } from "../../../functions/src/shareCode/Share_S_Format";
    import si_ticket from "@/components/a_smartIcons/si_ticket";

    import TqBtnApprove from "@/components/basic2/TqBtnApprove";
    import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
    import { obj_toArray_fo} from "../../../functions/src/shareCode/Share_S_Obj";
    import Si_maze_triangular from "@/components/a_smartIcons/si_maze_triangular";
    import FccDisplaySlidesData from "@/components/complex/TqDisplaySlidesData";
    import TqToggleDiv from "@/components/basic/TqToggleDiv";
    import TqMoreInfo from "@/components/basic2/TqMoreInfo";
    import TqToggleSwitch from "@/components/basic/TqToggleSwitch";
    import TqPricing from "@/components/basic/TqPricing";

    export default {
        name: "About",
        components:{
            TqPricing,
            TqToggleSwitch,
            TqMoreInfo,
            TqToggleDiv,
            FccDisplaySlidesData,
            Si_maze_triangular,
            TqLoaderContainer,
            TqBtnApprove,
            si_ticket,
            TqLoaderButton,
            TqTextarea,
            TqImagesCarousel,
            TqPopup,
            C_About_Locks,
            Si_fullLogo,
            TqImage,
            Si_maze,
            TqOnTopContainer,
            Si_Logo,
            TqCard
        },

        data(){
            return{

                features_o:{
                    selectedLevelLabel_e : null,
                    showPopup_moreInfo_vb : {val : false},
                    selectedFeatureLabel_e : null,
                },


                basicFeatures_ao:[
                    {name_s : 'identical text lock', },
                    {name_s : 'includes text lock',  },
                    {name_s : 'options lock',  },
                    {name_s : 'quiz lock',  },

                    {name_s : 'quest type - list',  },
                    {name_s : 'quest type - cards',  },

                    {name_s : 'max quest duration 3 hours',  },
                    {name_s : 'time extension',  },


                    {name_s : 'quest - play by players',  },
                    {name_s : 'quest - play by teams',  },

                    {name_s : 'headquarters ',  },

                    {name_s : 'drive ',  },

                    {name_s : 'chat ',  },

                ],

                advancedFeatures_ao:[
                    {name_s : 'image lock ', },
                    {name_s : 'video lock',  },
                    {name_s : 'Lock timer',  },

                    {name_s : 'quest type - map route'},
                    {name_s : 'quest type - map markers'},
                    {name_s : 'quest type - list group'},
                    {name_s : 'quest type - list levels'},
                    {name_s : 'quest type - cards different path teams '},
                    {name_s : 'quest type - cards map last missions '},
                    {name_s : 'quest type - cards map squares '},
                    {name_s : 'quest type - cards different path player '},
                    {name_s : 'quest type - map area'},

                    {name_s : 'max quest duration 7 days',  },

                    {name_s : 'clues',  },

                    {name_s : 'support multi language',  },

                    {name_s : 'skips ',  },

                    {name_s : 'chat translation ',  },
                    {name_s : 'chat translation ',  },
                    {name_s : 'discount coupons',  },
                    {name_s : 'last section',  },

                    {name_s : 'background image',  },
                    {name_s : 'edit quest audio',  },

                ],

                calcInputTickets_n : 10,
                pricingDeviceNum_n : 0,

                currentFeatureAnimatedIndex_n : 0,
                pricingIndex_n : 0,
                pricingIndex_col : 0,
                featurePopup_show_vb : {val : false},
                featurePopup_feature_o : null,

                ticketPricingTable_ticketNum_n : 0,
                selectedLevelIndex_n : 0,
                selectedLevelIconKey_n : 0,

                btn_showLoader_b : false,
                newCreatorInfo_o :{
                    name: "",
                    email: "",
                    phone: "",
                    moreInfo: "",
                },
                pricingCalculatorRows_ao : [
                    {eventTimeMinutes_n : 60, playersNum_n: 10},
                    {eventTimeMinutes_n : 120, playersNum_n: 10},
                    {eventTimeMinutes_n : 180, playersNum_n: 10},
                ],

                progress_selectedFeatureGroupLabel_s : "",

                // store
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),

                // server
                server_featureMoreInfo_byLabel_c : {},


                // imports
                ass_strings                 : ass_strings,
                enum_moveToOptions          : enum_moveToOptions,
                enum_levelMaxPoints         : enum_levelMaxPoints,
                enum_moreInfo_helpersIds_s  : enum_moreInfo_helpersIds_s,
                enum_moreInfoImgOptions_e    : enum_moreInfoImgOptions_e,
                ass_img_about_tqAppGif      : ass_img_about_tqAppGif,
                ass_img_about_multiPlatform : ass_img_about_multiPlatform,
                enum_featuresMinPoints : enum_featuresMinPoints,
                enum_articlesIds : enum_articlesIds,
                format_cost_s               : format_cost_s,

                ass_img_about_cards                 : ass_img_about_cards,
                ass_img_about_map_rectangles        : ass_img_about_map_rectangles,
                ass_img_about_map_route             : ass_img_about_map_route,
                ass_img_about_missionList           : ass_img_about_missionList,
                ass_img_about_missionList_levels    : ass_img_about_missionList_levels,
                ass_img_googleStore                 : ass_img_googleStore,
                ass_img_appStore                    : ass_img_appStore,
                ass_img_info2_b                     : ass_img_info2_b,
                ass_img_garbage_w                   : ass_img_garbage_w,
                ass_img_add_w                       : ass_img_add_w,
                ass_img_ticket2_g                   : ass_img_ticket2_g,
                ass_img_ticket2_blue                : ass_img_ticket2_blue,
                ass_img_ticket2_black               : ass_img_ticket2_black,
                ass_img_ticket2_o                   : ass_img_ticket2_o,
                ass_img_ticket2_p                   : ass_img_ticket2_p,
                ass_img_lock_w                      : ass_img_lock_w,
                ass_svg_map_w                       : ass_svg_map_w,
                ass_img_idea_w                      : ass_img_idea_w,
                ass_img_playersGroup_b              : ass_img_playersGroup_b,
                ass_img_edit_b                      : ass_img_edit_b,
                ass_img_checked_b                   : ass_img_checked_b,
                ass_img_xLetter_b                   : ass_img_xLetter_b,

                ass_svg_museum_purple               : ass_svg_museum_store,
                ass_svg_schools_purple              : ass_svg_schools_store,
                ass_svg_nonProfit_purple            : ass_svg_nonProfit_store,
                ass_svg_store_black                 : ass_svg_store_black,
                ass_img_tickets_b                   : ass_img_tickets_b,
                ass_image_coming_soon               : ass_image_coming_soon,

                helper_getDirectionByLangCode_fe    : helper_getDirectionByLangCode_fe,
                format_bigNumber_fs                 : format_bigNumber_fs,
                route_moveToRoute                   : route_moveToRoute
            }
        },
        methods:{
            m_sendEmailToCreator_f(){

                this.btn_showLoader_b = true

                let newCreator_s    = "<div> New Creator: </div>"
                let name_s          = "<div> Name: "  + this.newCreatorInfo_o.name + "</div>"
                let email_s         = "<div> Email: "  + this.newCreatorInfo_o.email + "</div>"
                let phone_s         = "<div> Phone: " + this.newCreatorInfo_o.phone + "</div>"
                let moreInfo_s      = "<div> MoreInfo: " + this.newCreatorInfo_o.moreInfo + "</div>"

                let sendEmail_c = new FB_SendEmail({
                    se_sendToEmail_s: "dan@travelandquest.com",
                    se_title_s      : "New Creator",
                    se_message_s    : newCreator_s + name_s + email_s + phone_s + moreInfo_s,
                })

                server_sendMail_fp(sendEmail_c).then( () => {
                    this.btn_showLoader_b = false
                    notification_notify(ass_strings.twoWords_sentEmail)
                    this.newCreatorInfo_o.phone = ""
                    this.newCreatorInfo_o.moreInfo = ""
                    this.newCreatorInfo_o.name = ""
                    this.newCreatorInfo_o.email = ""
                })

            },
            m_moveToArticlePage_f(articleId_uid){
                // route_moveToRoute(enum_moveToOptions.player_blog_item + "/" + articleId_uid)
            },

            m_openAppStore_f(){
                route_openNewWindow_f(gv_urls.appStore)
            },
            m_openGoogleStore_f(){
                route_openNewWindow_f(gv_urls.googleStore)
            },

            m_featureMoreInfo_c(fmi_id_e) {

                if (this.server_featureMoreInfo_byLabel_c[fmi_id_e] === undefined) {
                    this.$set(this.server_featureMoreInfo_byLabel_c, fmi_id_e, null)

                    serverPre_moreInfo_get_one_f({
                        mi_id_uid : fmi_id_e,
                        cb_f: (featureMoreInfo_c) =>{
                            this.server_featureMoreInfo_byLabel_c[fmi_id_e] = featureMoreInfo_c
                        }
                    })
                }
                return this.server_featureMoreInfo_byLabel_c[fmi_id_e]
            },
            m_features_clickFeature_f(fmi_id_e){
                this.features_o.selectedFeatureLabel_e =  fmi_id_e
                this.features_o.showPopup_moreInfo_vb.val =  true


            }
        },

    }
</script>

<style scoped lang="scss">

    .lc_appStore{max-width: 120px;}

    table.lc_ticketPricingTable{
        //border:1px solid black;
        border-spacing: 2px;
        td{

            //border: 1px solid black;
        }
    }

    .lc_pricingTable{
        border-collapse: collapse;
    }

    .lc_pricing_freePlan{
        /*border: 2px solid var(--color-green);*/
        background: rgba(249,166,2,0.2);
        box-shadow: 0 2px 4px 0 rgba(60,179,113,0.8);
    }
    .lc_pricing_firstPlan{
        background: rgba(59,89,152,0.2);
        box-shadow: 0 2px 4px 0 rgba(59,89,152,0.8);
    }

</style>
